import IBlock3Employee from "./IBlock3Employee";
import IAddress from "./IAddress";
import Address from "./Address";
import { EnumUtil } from "@/app";

export default class Block3Employee implements IBlock3Employee {
    constructor(
        public address: IAddress = new Address(),
        public contractDurationType: string = EnumUtil.EMPTY_OPTION,
        public contractDurationValidity: Date | undefined = undefined,
        public employerName: string = "",
        public businessId: string = "",
    ) {
    }
}